import { IReviewStatistic } from "../types";

export const transformRateCountReviews = (rateCount: number): string => {
  if (rateCount < 100) {
    return rateCount.toString();
  } else if (rateCount >= 100 && rateCount < 1000) {
    // round to nearest 50 between 100 and 1000
    return Math.round(rateCount / 50) * 50 + "+";
  } else {
    // round to nearest 500 if count more than 1000
    return (Math.round(rateCount / 500) * 500) / 1000 + "k+";
  }
};

export const getTheStars = (rate: number) => {
  const stars = [];

  for (let l = 1; l <= 5; l++) {
    let src = "/icons/star-full-blue.svg";
    if (l > rate) {
      src = "/icons/star-empty-grey.svg";
    }
    stars.push(src);
  }

  return stars;
};

export const calcReviewsCount = (rating: IReviewStatistic["rating"] = []): number =>
  rating.reduce((acc, { amountOfRates }) => acc + amountOfRates, 0);

export const calcAvgRating = (rating: IReviewStatistic["rating"] = []): string => {
  const ratingSum: number = rating.reduce(
    (sum: number, rating: { score: number; amountOfRates: number }) =>
      sum + rating.score * rating.amountOfRates,
    0,
  );

  const ratingCount: number = rating.reduce((sum, rating) => sum + rating.amountOfRates, 0);
  const decimal: number = ratingSum / ratingCount;
  const avgRating: string = Number.isNaN(decimal) ? "0" : decimal.toFixed(1);

  return avgRating;
};
